import { RouterProvider } from 'react-router';
import { router } from './routes.tsx';
import { ErrorBoundary } from './components/ui/ErrorBoundary.tsx';
import { ThemeProvider } from './components/layout/ThemeProvider.tsx';

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </ErrorBoundary>
  );
}
